module.exports = __webpack_public_path__ + "img/cf.f7f97a73.svg";